import withStyles from "@material-ui/core/styles/withStyles";
import { IStore, AppDispatch } from "../store";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { DriverStateDTO, Race } from "../api/model";
import { Theme, WithStyles, Paper, Grid, Typography } from "@material-ui/core";
import { mockTheme, WithActions, toMap } from "../utils/utils";
import { RaceActions } from "../store/race/race-actions";
import { connect } from "react-redux";
import StoreModel, {
  LoadedResource,
  LoadedSingleResource,
} from "../store/StoreModel";
import RaceDataComponent from "../components/race/RaceDataComponent";
import RaceTrace from "../components/race/RaceTrace";
import { bindActionCreators } from "redux";
import { DriverActions } from "../store/driver";
import { ConfigData } from "../config";
import RaceMiscActions from "src/components/race/RaceMiscActions";
import { OrderActions } from "src/store/order";
import RaceDeliveryComponent from "src/components/race/RaceDeliveryComponent";
import { NotificationActions } from "src/store/notification/notification-actions";

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
});

const classesType = styles(mockTheme);

interface RacePageProps
  extends RouteComponentProps<{ id: string }>,
    WithStyles<keyof typeof classesType>,
    WithActions<RaceActions> {
  driverActions: DriverActions;
  config: ConfigData;
  race: LoadedSingleResource<Race>;
  driverLocations: { [k: string]: LoadedSingleResource<DriverStateDTO> };
  order: LoadedResource<any>;
  orderActions: OrderActions;
  notificationActions: NotificationActions;
}

class RacePage extends React.Component<RacePageProps, any> {
  trace?: NodeJS.Timer;

  constructor(props: RacePageProps) {
    super(props);
  }

  componentDidMount() {
    this.props.orderActions.fetchByRace(this.props.match.params.id);
    this.props.actions.fetchWithDriverInfo(this.props.match.params.id, false);
    this.trace = setInterval(() => {
      this.props.actions.fetchWithDriverInfo(this.props.match.params.id, true);
    }, 1000 * 10);
  }

  componentWillUnmount() {
    if (this.trace) {
      clearInterval(this.trace);
    }
  }

  /**
   * Este componente no debería re renderizarse una vez que ya
   * se haya cargado al menos una vez la carrera.
   *
   * @param nextProps the next props
   */
  shouldComponentUpdate(nextProps: RacePageProps) {
    if (nextProps.match.params.id === this.props.match.params.id) {
      if (
        StoreModel.isLoaded(nextProps.race) &&
        StoreModel.isLoaded(this.props.race) &&
        StoreModel.isLoaded(this.props.order)
      ) {
        return false;
      }
    }
    return true;
  }

  renderRace(race: Race) {
    const driver = race.driver;

    return (
      <Grid container spacing={16}>
        <Grid item sm={12} md={6} lg={6}>
          {this.props.order.data && this.props.order.data.length > 0 && (
            <Paper elevation={5} style={{ padding: 10 }}>
              <RaceDeliveryComponent order={this.props.order.data} />
            </Paper>
          )}
          <br />
          <Paper elevation={5} style={{ padding: 10 }}>
            <RaceTrace
              raceId={race.id}
              driverId={driver ? driver.id : null}
              config={this.props.config}
            />
          </Paper>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
          <Paper elevation={5} style={{ padding: 10 }}>
            <RaceMiscActions
              race={race}
              notificationActions={this.props.notificationActions}
            />
            <RaceDataComponent race={race} />
          </Paper>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes, race } = this.props;

    if (StoreModel.isLoading(race)) {
      return <div>Cargando...</div>;
    }
    if (StoreModel.isError(race)) {
      return (
        <Grid container className={classes.root} spacing={16}>
          <Grid item xs={12}>
            <Paper elevation={11} style={{ padding: 40, textAlign: "center" }}>
              <Typography variant="display2" style={{ paddingBottom: 20 }}>
                :(
              </Typography>
              <Typography variant="title">
                La carrera que buscas no se ha podido cargar
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      );
    }

    return this.renderRace(race.data!);
  }
}

const mapStateToProps = (state: IStore, ownProps: RacePageProps) => ({
  ...ownProps,
  race: state.race.byId[ownProps.match.params.id],
  driver: state.driver.locationById,
  config: state.config.data,
  order: state.order.data,
});

const styled = withStyles(styles as any)(RacePage);
// const connected = connect(mapStateToProps, bindActions(RaceActions))(styled as any);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
  return {
    actions: bindActionCreators(toMap(RaceActions), dispatch),
    driverActions: bindActionCreators(toMap(DriverActions), dispatch),
    orderActions: bindActionCreators(toMap(OrderActions), dispatch),
    notificationActions: bindActionCreators(
      toMap(NotificationActions),
      dispatch
    ),
  };
})(styled);

export default connected as React.ComponentClass<Partial<RacePageProps>>;



// WEBPACK FOOTER //
// ./src/pages/RacePage.tsx